export default "__VITE_ASSET__rZS14ujf__"